import {
  SET_LOCATION,
  SET_PLACE,
  SEARCH_BY_PLACE,
  SELECT_RESTAURANT,
  SET_TABLE_NUMBER,
  SHOW_RESULTS,
  HIDE_RESULTS,
} from './actions';

import calcDistance from '../../../common/utils/calc-distance';

const getIsWithinDistance =
  (distance) =>
  (location) =>
  ({ coordinates: { latitude, longitude } }) =>
    calcDistance({ latitude, longitude }, location) < distance;
const getHasPlace =
  (place) =>
  ({ address: { line1, city }, shortName }) => {
    const wholeAddress = `${line1} ${city} ${shortName}`;
    return wholeAddress.toUpperCase().indexOf(place.toUpperCase()) !== -1;
  };

export default (state, action) => {
  const { restaurants, distance } = state;
  const { type } = action;

  switch (type) {
    case SET_LOCATION: {
      const { location } = action;
      const isWithinDistance = getIsWithinDistance(distance);
      const resultLength = restaurants.filter(isWithinDistance(location)).length;

      return {
        ...state,
        areResultsVisible: true,
        resultLength,
        results: resultLength >= 1 ? restaurants.filter(isWithinDistance(location)) : restaurants,
      };
    }
    case SET_PLACE: {
      const { results } = state;
      const { place } = action;
      return {
        ...state,
        place,
        results: !place ? [...restaurants] : results,
      };
    }
    case SEARCH_BY_PLACE: {
      const { place } = state;
      const resultLength = restaurants.filter(getHasPlace(place));
      return {
        ...state,
        areResultsVisible: !!place,
        resultLength,
        results: restaurants.filter(getHasPlace(place)),
      };
    }
    case SELECT_RESTAURANT: {
      const { selectedRestaurant } = action;
      return {
        ...state,
        selectedRestaurant,
      };
    }
    case SET_TABLE_NUMBER: {
      const { tableNumber } = action;
      return {
        ...state,
        tableNumber,
      };
    }
    case SHOW_RESULTS: {
      return {
        ...state,
        areResultsVisible: true,
      };
    }
    case HIDE_RESULTS: {
      return {
        ...state,
        areResultsVisible: false,
      };
    }
    default:
      return state;
  }
};
